exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".op-input .op-input-txt{display:inline-block;min-width:30px;color:#666}input::-webkit-outer-spin-button,input::-webkit-inner-spin-button{-webkit-appearance:none}\n", ""]);

// exports
